import React from "react";
import { Routes, Route} from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import ACGVOPage from "./components/ACGVOPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MentionsLegales from "./components/MentionsLegales";
import ContactForm from "./components/ContactForm";
import NotFound from "./components/NotFound";
import ContactUs from "./components/ContactUs";

function App() {
  return (

    <BrowserRouter>


    {/* En-tête visible sur toutes les pages */}
    <Header />

    {/* Contenu principal avec Routes */}
    <div className="main-content">
      <Routes>
        {/* Page d'accueil */}
        <Route path="/" element={<ACGVOPage /> } />

        {/* Page des voitures */}
        <Route path="/mention-legales" element={<MentionsLegales />} />
        <Route path="/ContactUs" element={<ContactUs />} />

        {/* Page des services 
        <Route path="/services" element={<Services />} />
        <Route path="/info" element={<Informations />} />
        <Route path="/informations" element={<Informations />} />
        <Route path="/links" element={<Links />} />

        */}
        {/* Page de contact */}
        <Route path="/contact" element={<ContactForm />} />

        {/* Page 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>

    {/* Pied de page visible sur toutes les pages */}
    <Footer />
  </BrowserRouter>

  );
}

export default App;
